
import EventBus from '@/utils/event-bus'
import { getmerchantIndexApi, bankListApi, merchantHelperApi, getContentListApi, merchantUserinfoApi } from "@/api/shop";
import { Message, Loading } from 'element-ui';
import { getbusinessInfoapi } from "@/api/user";

export default {
  SET_MERCHANTINDEXA(context) {
    let { commit, dispatch } = context;
    try {
      EventBus.$emit('upload_merchant', JSON.stringify({ loading: true }))
      merchantUserinfoApi().then((res) => {
        commit('SET_MERCHANTCODE', res.data.status_format.code)
        if (res.data.status_format.code == 1) dispatch('GET_MERCHANTHELPERA')
      })
      getmerchantIndexApi()
        .then((res) => {
          if (res.status == 200)  commit('SET_MERCHANTINDEX', res.data)
        })
        .finally(() => {
          EventBus.$emit('upload_merchant', JSON.stringify({ loading: false }))
        })

    } catch (error) {
      Message(error);
    }

  },
  GET_MERCHANTHELPERA(context) {
    let { commit } = context;
    try {
      EventBus.$emit('upload_merchant', JSON.stringify({ loading: true }))
      merchantHelperApi()
        .then((res) => {
          if (res.status == 200) {
            commit('GET_MERCHANTHELPER', res.data)
          }
        }).finally(() => {
          EventBus.$emit('upload_merchant', JSON.stringify({ loading: false }))
        })

    } catch (error) {
      Message(error);
    }
  },
  SET_MYBANKLISTA(context) {
    let { commit } = context;
    try {
      bankListApi()
        .then((res) => {
          if (res.status == 200) commit('SET_MYBANKLIST', res.data.list)
        })
    } catch (error) {
      Message(error);
    }

  },
  GET_EMAILLISTA(context) {
    let { commit } = context;
    try {
      getContentListApi()
        .then((res) => {
          if (res.status == 200) commit('GET_EMAILLIST', res.data)
        })

    } catch (error) {
      Message(error);
    }

  },
  GET_CARDINFOA(context) {
    let { commit } = context;
    getbusinessInfoapi()
      .then((res) => {
        if (res.status == 200) commit('SET_CARDINFO', res.data)
      })
  }
};
